const LEVELS = [
    { label: 'Too weak', color: '#dc2626' },
    { label: 'Weak', color: '#ea580c' },
    { label: 'Fair', color: '#ca8a04' },
    { label: 'Good', color: '#65a30d' },
    { label: 'Strong', color: '#16a34a' },
];

const CHECKS = [
    { label: 'At least 10 characters', test: (value) => value.length >= 10 },
    { label: 'Upper and lower case letters', test: (value) => /[a-z]/.test(value) && /[A-Z]/.test(value) },
    { label: 'A number', test: (value) => /\d/.test(value) },
];

const score = (value) => {
    if (!value) {
        return -1;
    }

    const passed = CHECKS.filter((check) => check.test(value)).length;
    const bonus = (value.length >= 14 ? 1 : 0) + (/[^A-Za-z0-9]/.test(value) ? 1 : 0);

    if (passed < CHECKS.length) {
        return Math.min(passed, 1);
    }

    return Math.min(2 + bonus, LEVELS.length - 1);
};

const buildMeter = () => {
    const wrapper = document.createElement('div');
    wrapper.setAttribute('aria-live', 'polite');
    wrapper.style.cssText = 'margin-top:0.5rem;font-size:0.75rem;';
    wrapper.hidden = true;

    const track = document.createElement('div');
    track.style.cssText = 'height:6px;border-radius:9999px;background:#e5e7eb;overflow:hidden;';
    const bar = document.createElement('div');
    bar.style.cssText = 'height:100%;width:0;transition:width .2s,background-color .2s;';
    track.appendChild(bar);

    const label = document.createElement('p');
    label.style.cssText = 'margin:0.25rem 0 0;font-weight:600;';

    const list = document.createElement('ul');
    list.style.cssText = 'margin:0.25rem 0 0;padding:0;list-style:none;';
    const items = CHECKS.map((check) => {
        const item = document.createElement('li');
        item.textContent = check.label;
        list.appendChild(item);

        return item;
    });

    wrapper.append(track, label, list);

    return { wrapper, bar, label, items };
};

const attach = (input) => {
    const meter = buildMeter();
    const anchor = input.closest('[data-password-strength-anchor]') ?? input;
    anchor.insertAdjacentElement('afterend', meter.wrapper);

    input.addEventListener('input', () => {
        const value = input.value;
        const current = score(value);

        meter.wrapper.hidden = current < 0;

        if (current < 0) {
            return;
        }

        const level = LEVELS[current];
        meter.bar.style.width = `${((current + 1) / LEVELS.length) * 100}%`;
        meter.bar.style.backgroundColor = level.color;
        meter.label.textContent = level.label;
        meter.label.style.color = level.color;

        CHECKS.forEach((check, index) => {
            const met = check.test(value);
            meter.items[index].textContent = `${met ? '✓' : '•'} ${check.label}`;
            meter.items[index].style.color = met ? '#16a34a' : '#6b7280';
        });
    });
};

document.querySelectorAll('input[data-password-strength]').forEach(attach);
